import styled from "styled-components";

export const ModalAutoTsuccessContainer = styled.div`
    width: 359px;
    height: 304px;
    background-color: var(--color-broccoli);
    border-radius: 8px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto; 
    .backgorund-containerModalAutoT {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        z-index: -1;
        background: hsla(0, 0%, 0%, 0.5);
    }                        
    p {
        width: 90%;
        text-align: center;
        font-weight: 500;
        font-size: 18px; 
        line-height: 150%;
        color: var(--color-white); 
    }
    button {
        width: 300px;
        height: 45px;
        border: 2px solid var(--color-white);
        border-radius: 8px;
        background-color: transparent;
        color: var(--color-white); 
        font-size: 18px;
    }
    .cruz-circle {
        border:  3.5px solid var(--color-white);
        width: max-content;
        height: max-content;
        border-radius: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 10px;
    }

    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 30px;
`;

